module.exports = __webpack_public_path__ + "static/img/ent-76.0301376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-76.jpg
// module id = syJu
// module chunks = 51